var _filter, _rect, _g, _g2, _g3, _g4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 400,
    height: 200,
    viewBox: "0 0 400 200",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "goldGradient",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#FFD700",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "50%",
    style: {
      stopColor: "#FFA500",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#FF8C00",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "silverGradient",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#C0C0C0",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "50%",
    style: {
      stopColor: "#A0A0A0",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#808080",
      stopOpacity: 1
    }
  })), _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
    id: "shadow",
    x: "-20%",
    y: "-20%",
    width: "140%",
    height: "140%"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 2,
    dy: 2,
    stdDeviation: 3,
    floodColor: "#000000",
    floodOpacity: 0.3
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 400,
    height: 200,
    fill: "#000000"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#shadow)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 180 40 L 200 20 L 220 40 L 240 35 L 235 50 L 165 50 L 160 35 Z",
    fill: "url(#goldGradient)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 200,
    cy: 25,
    r: 3,
    fill: "url(#goldGradient)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 185,
    cy: 45,
    r: 2,
    fill: "url(#goldGradient)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 215,
    cy: 45,
    r: 2,
    fill: "url(#goldGradient)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fontFamily: "serif",
    fontSize: 48,
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("text", {
    x: 160,
    y: 90,
    fill: "url(#goldGradient)",
    textAnchor: "middle"
  }, "S"), /*#__PURE__*/React.createElement("text", {
    x: 200,
    y: 90,
    fill: "url(#silverGradient)",
    textAnchor: "middle"
  }, "V"))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    fontFamily: "serif",
    fontSize: 24,
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("text", {
    x: 200,
    y: 120,
    textAnchor: "middle"
  }, /*#__PURE__*/React.createElement("tspan", {
    fill: "url(#goldGradient)"
  }, "SV "), /*#__PURE__*/React.createElement("tspan", {
    fill: "url(#silverGradient)"
  }, "ROYAL")))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    fontFamily: "serif",
    fontSize: 24,
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("text", {
    x: 200,
    y: 150,
    textAnchor: "middle",
    fill: "url(#goldGradient)"
  }, "LUXURY ROOMS"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.3a58c816b2ab2d59fca5d490fff88110.svg";
export { ForwardRef as ReactComponent };